<h1 mat-dialog-title >{{data.title}}</h1>
<mat-card-content>
  <form [formGroup]="menajeriaForm">

    <div style="display: flex;justify-content: space-around;flex-wrap: wrap">

      <div style="flex-direction: column;display: flex">
        <h4 style="font-weight: bold">Artículo</h4>
        <mat-form-field appearance="outline" >
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="nombre" name="nombre" required>
        </mat-form-field>

        <mat-form-field appearance="outline" >
          <mat-label>Marca</mat-label>
          <input matInput placeholder="Marca" formControlName="marca" name="marca" required>
        </mat-form-field>

        <mat-form-field appearance="outline" >
          <mat-label>Modelo</mat-label>
          <input matInput placeholder="Modelo" formControlName="modelo" name="modelo" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input matInput placeholder="cantidad"formControlName="cantidad" name="cantidad" required type="number">
        </mat-form-field>

      </div>


      <div style="flex-direction: column;display: flex" formGroupName="factura">
        <h4 style="font-weight: bold">Factura</h4>
        <mat-form-field appearance="outline">
          <mat-label>Razón Social</mat-label>
          <input matInput placeholder="Razón Social"formControlName="razonSocial" name="razonSocial" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>RUC</mat-label>
          <input matInput placeholder="RUC"formControlName="ruc" name="ruc" required>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Número de Factura</mat-label>
          <input matInput placeholder="Número de Factura"formControlName="numFactura" name="numFactura" required>
        </mat-form-field>


      </div>

    </div>

    <mat-dialog-actions align="center">
      <button mat-raised-button mat-dialog-close>Cancelar</button>
      <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==1" (click)="updateMenajeria()">{{data.title}}</button>
      <button mat-raised-button style="background-color: #e95a1a;color: white" *ngIf="this.data.estado==2" (click)="createMenajeria()">{{data.title}}</button>
    </mat-dialog-actions>

  </form>

</mat-card-content>
